import React from 'react';
import { useSelector } from 'react-redux';
import Table from 'components/Table';

import { getPValue } from 'utilities';
import { round6 } from 'utilities/math';

import {
  getAltHypotesisSign,
  getH0,
  getH1,
  getTableData,
  getPValue as getPValueFromStore,
  getTStatistics,
  getStandardError,
  getDfValue,
  getDF
} from 'store/scenes/inferentialStatistics/selectors';

import { tableHeadersTwoSampleT } from '../shared';

const TwoSampleTHypothesis = () => {
  const altHypothesisSign = useSelector(state => getAltHypotesisSign(state));
  const h0 = useSelector(state => getH0(state));
  const h1 = useSelector(state => getH1(state));
  const tableData = useSelector(state => getTableData(state));
  const tStatistics = useSelector(state => getTStatistics(state));
  const pValue = useSelector(state => getPValueFromStore(state));
  const standardError = useSelector(state => getStandardError(state));
  const dfValue = useSelector(state => getDfValue(state));
  const df = useSelector(state => getDF(state));

  return (
    <div className="content-item">
      <h3 className="mb-20">Two Sample <i>t</i> Hypothesis Test Summary</h3>
      <div className="mb-5 pl-5">
        <p className="font-900 font-16 mb-5">μ1: mean of population #1</p>
        <p className="font-900 font-16">μ2: mean of population #2</p>
      </div>
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Null Hypothesis</td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>0</sub>: μ1 - μ2 =
              </span>
              <span>{round6(h0)}</span>
            </td>
          </tr>
          <tr>
            <td className="pb-20">Alternative Hypothesis</td>
            <td className="pb-20">
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>1</sub>: μ1 - μ2 {altHypothesisSign}
              </span>
              <span>{round6(h1)}</span>
            </td>
          </tr>
          <tr>
            <td>Difference of Means</td>
            <td>
              <span>{round6(dfValue)}</span>
            </td>
          </tr>
          <tr>
            <td>T-Statistic</td>
            <td>
              <span>{round6(tStatistics)}</span>
            </td>
          </tr>
          <tr>
            <td>P-Value</td>
            <td>
              <span>{getPValue(pValue)}</span>
            </td>
          </tr>
          <tr>
            <td>df</td>
            <td>
              <span>{round6(df)}</span>
            </td>
          </tr>
          <tr>
            <td>Standard Error</td>
            <td>
              <span>{round6(standardError)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeadersTwoSampleT} tableData={tableData} />
    </div>
  );
};

export default TwoSampleTHypothesis;
